import { Component, Input } from '@angular/core';

interface User {
  username: string;
  id: number;
  avatar?: string;
}

type AvatarSize =
  | 'xsmall'
  | 'small'
  | 'mid'
  | 'large'
  | 'xlarge'
  | 'circle'
  | undefined;

@Component({
  selector: 'fl-user-avatar',
  template: `
    <div class="UserAvatar" *ngIf="!isMulti()"
      [attr.data-size]="size"
    >
      <img class="UserAvatar-img"
        *ngIf="hasPic(users[0])" src="{{users[0].avatar}}"
      >
      <div class="UserAvatar-letter" *ngIf="!hasPic(users[0])">
        {{getLetter(users[0])}}
      </div>
      <fl-online-status class="UserAvatar-onlineStatus"
        [user]="users[0]"
      >
      </fl-online-status>
    </div>

    <div class="UserAvatar-multi" *ngIf="isMulti()">
      <div class="UserAvatar-multi-row">
        <div class="UserAvatar-content">
          <img class="UserAvatar-multi-img"
            *ngIf="hasPic(users[0])"
            src="{{users[0].avatar}}"
          >
          <div class="UserAvatar-multi-letter" *ngIf="!hasPic(users[0])">
            {{getLetter(users[0])}}
          </div>
        </div>

        <div class="UserAvatar-content">
          <img class="UserAvatar-multi-img"
            *ngIf="users.length > 2 && hasPic(users[1])"
            src="{{users[1].avatar}}"
          >
          <div class="UserAvatar-multi-letter" *ngIf="users.length > 2 && !hasPic(users[1])">
            {{getLetter(users[1])}}
          </div>
        </div>
      </div>

      <div class="UserAvatar-multi-row UserAvatar-multi-row--secondary">
        <div class="UserAvatar-content">
          <img class="UserAvatar-multi-img"
            *ngIf="users.length > 2 && hasPic(users[2])"
            src="{{users[2].avatar}}"
          >
          <div class="UserAvatar-multi-letter" *ngIf="users.length > 2 && !hasPic(users[2])">
            {{getLetter(users[2])}}
          </div>
        </div>

        <div class="UserAvatar-content">
          <img class="UserAvatar-multi-img"
            *ngIf="bottomRightUser() && hasPic(bottomRightUser())"
            src="{{bottomRightUser().avatar}}">
          <div class="UserAvatar-multi-letter" *ngIf="bottomRightUser() && !hasPic(bottomRightUser())">
            {{getLetter(bottomRightUser())}}
          </div>
          <div class="UserAvatar-multi-letter" *ngIf="!bottomRightUser() && users.length > 4">
            {{bottomRightText()}}
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./user-avatar.component.scss'],
})
export class UserAvatarComponent {
  @Input() users: User[];
  @Input() size: AvatarSize = 'mid';

  isMulti() {
    if (this.users) {
      return this.users.length > 1;
    }
  }

  hasPic(user: User) {
    return user.avatar && !user.avatar.includes('unknown.png');
  }

  getLetter(user: User) {
    return user.username[0].toUpperCase();
  }

  bottomRightUser() {
    if (this.users.length === 2) {
      return this.users[1];
    } else if (this.users.length === 4) {
      return this.users[3];
    }
  }

  bottomRightText() {
    return this.users.length > 4 ? `${this.users.length}+` : '';
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/zh/webapp/src/app/@shared/ui/user-avatar/user-avatar.component.ts